import useTrans from '../../../hooks/useTrans'
import { trackingAddCart } from '../../../utils/gtm.js'
import { Button, Trans } from '../../atoms'
import { Cart, Clock } from '../../atoms/NewIcons'
import DataTableRowCreaOfferta from '../DataTableRowCreaOfferta/DataTableRowCreaOfferta.jsx'
import DatatableRowCart from '../DatatableRowCart/DatatableRowCart'
import DatatableRowPersonalizzazione from '../DatatableRowPersonalizzazione/DatatableRowPersonalizzazione'

const ArticoliPersonalizzati = ({
  righe,
  salvati = false,
  MoveToMainPersonalizzazione,
  MoveToLaterPersonalizzazione,
  MoveToLater,
  Delete,
  setOpenModalNota,
  setId,
  setCodice,
  setNota,
  setOpenModalRimuovi,
  setOpenModalQuantita,
  EliminaPersonalizzazione,
  carrelloMain,
  creaOfferta,
}) => {
  const t = useTrans()
  return (
    <>
      {righe.map((item) => (
        <div className="articoli-personalizzati__block" key={item.id}>
          {!creaOfferta && (
            <div className="articoli-personalizzati__block-head">
              <p className="articoli-personalizzati__subtitle">
                <Trans chiave="Personalizzazione" /> {item.nome_lavorazione}
              </p>
              {salvati ? (
                <Button
                  className="articoli-personalizzati__head-button"
                  variant="ghost"
                  colorVariant="black"
                  size="medium"
                  label={t('Sposta nel carrello')}
                  icon={<Cart />}
                  icon_pos="left"
                  onClick={() => {
                    MoveToMainPersonalizzazione(item.id)
                    trackingAddCart(item, "standard_order")
                  }}
                  disabled={!MoveToMainPersonalizzazione}
                />
              ) : (
                <Button
                  className="articoli-personalizzati__head-button"
                  variant="ghost"
                  colorVariant="black"
                  size="medium"
                  label={t('Salva per dopo')}
                  icon={<Clock />}
                  icon_pos="left"
                  onClick={() => MoveToLaterPersonalizzazione(item.id)}
                  disabled={!MoveToLaterPersonalizzazione}
                />
              )}
            </div>
          )}
          {item.righe_carrello.map((element, _i) =>
            creaOfferta ? (
              <DataTableRowCreaOfferta
                riga={element}
                rigaId={element?.id}
                personalizzazioneId={element?.personalizzazione_carrello_id}
                creaOfferta={creaOfferta}
                margineInput={creaOfferta?.margineInput}
                totaleQuotazione={creaOfferta?.totaleQuotazione}
                preview={creaOfferta?.preview}
                articolo={element.articolo}
                quantita={element.quantita}
                key={element.id}
                even={_i % 2 == 0}
              />
            ) : (
              <DatatableRowCart
                carrelloMain={carrelloMain}
                isSalvatoPerDopo={salvati}
                isPersonalizzato={true}
                isPersonizzabile={!element.escludi_da_listino_di_stampa}
                articolo={element.articolo}
                quantita={element.quantita}
                key={element.id}
                id={element.id}
                riga={element}
                nota={element.nota}
                MoveToLater={!salvati && MoveToLater}
                Delete={Delete}
                setOpen={setOpenModalNota}
                setId={setId}
                saveCodice={setCodice}
                setNota={setNota}
                setDeleteOpen={setOpenModalRimuovi}
                setOpenModalQuantita={setOpenModalQuantita}
                even={_i % 2 == 0}
              />
            )
          )}

          <DatatableRowPersonalizzazione
            creaOfferta={creaOfferta}
            onDelete={() => EliminaPersonalizzazione(item?.righe_carrello)}
            id={item.id}
            quantita={item?.quantita_personalizzazione}
            prezzo_personalizzazione_unitario={
              item?.righe_carrello[0].prezzo_personalizzazione_unitario
            }
            stesso_logo={item.stesso_logo}
            posizione={item.posizioni[0].personalizzazione.posizione.nome}
            numero_colori={item.posizioni[0].personalizzazione.numero_colori_descrizione}
            posizioni={item.posizioni}
            totale_personalizzazione={item.totale_personalizzazione}
            tecnica={item.posizioni[0].personalizzazione.tecnica.nome}
            prodotto={item.posizioni ? item.posizioni[0].personalizzazione.prodotto : null}
            codice={item.righe_carrello[0]?.articolo?.codice}
          />
        </div>
      ))}
    </>
  )
}

export default ArticoliPersonalizzati
